module.exports = __webpack_public_path__ + "img/SER-A-1-I.473007a9.png";